(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    







  /*



    BBC DESKTOP NAV CENTERING



    Centers the written desktop navigation in the actual free space



    between the visible logo and the Account / Cart area.



    Mobile / iPad portrait remain untouched.



  */



  const bbcCenterDesktopNavigation = () => {



    const landscapeDesktop = window.matchMedia(



      '(min-width: 990px) and (orientation: landscape)'



    );







    const header = document.querySelector('.header');



    const nav = header?.querySelector('.bbc-desktop-nav');



    const heading = header?.querySelector('.header__heading');



    const icons = header?.querySelector('.header__icons');







    if (!header || !nav) return;







    if (!landscapeDesktop.matches || !heading || !icons) {



      header.style.removeProperty('--bbc-desktop-nav-center');



      return;



    }







    const headerRect = header.getBoundingClientRect();



    const logoRect = heading.getBoundingClientRect();



    const iconsRect = icons.getBoundingClientRect();







    const freeSpaceLeft = logoRect.right;



    const freeSpaceRight = iconsRect.left;







    if (freeSpaceRight <= freeSpaceLeft) {



      header.style.removeProperty('--bbc-desktop-nav-center');



      return;



    }







    const centerInViewport =



      freeSpaceLeft + (freeSpaceRight - freeSpaceLeft) / 2;







    const centerInsideHeader =



      centerInViewport - headerRect.left;







    header.style.setProperty(



      '--bbc-desktop-nav-center',



      `${centerInsideHeader}px`



    );



  };







  const bbcScheduleDesktopNavigationCenter = () => {



    requestAnimationFrame(() => {



      bbcCenterDesktopNavigation();



      requestAnimationFrame(bbcCenterDesktopNavigation);



    });



  };







  document.addEventListener(



    'DOMContentLoaded',



    bbcScheduleDesktopNavigationCenter



  );







  window.addEventListener(



    'load',



    bbcScheduleDesktopNavigationCenter



  );







  window.addEventListener(



    'resize',



    bbcScheduleDesktopNavigationCenter,



    { passive: true }



  );







  window.addEventListener(



    'orientationchange',



    bbcScheduleDesktopNavigationCenter



  );











  class StickyHeader extends HTMLElement {







    constructor() {



      super();



    }







    connectedCallback() {







      this.header = document.querySelector('.section-header');







      this.headerIsAlwaysSticky =



        this.getAttribute('data-sticky-type') === 'always' ||



        this.getAttribute('data-sticky-type') === 'reduce-logo-size';







      this.headerBounds = {};







      this.setHeaderHeight();







      window



        .matchMedia('(max-width: 1100px)')



        .addEventListener(



          'change',



          this.setHeaderHeight.bind(this)



        );







      if (this.headerIsAlwaysSticky) {



        this.header.classList.add(



          'shopify-section-header-sticky'



        );



      }







      this.currentScrollTop = 0;



      this.preventReveal = false;







      this.predictiveSearch =



        this.querySelector('predictive-search');







      this.onScrollHandler =



        this.onScroll.bind(this);







      this.hideHeaderOnScrollUp =



        () => (this.preventReveal = true);







      this.addEventListener(



        'preventHeaderReveal',



        this.hideHeaderOnScrollUp



      );







      window.addEventListener(



        'scroll',



        this.onScrollHandler,



        false



      );







      this.createObserver();







    }







    setHeaderHeight() {







      document.documentElement.style.setProperty(



        '--header-height',



        `${this.header.offsetHeight}px`



      );







    }







    disconnectedCallback() {







      this.removeEventListener(



        'preventHeaderReveal',



        this.hideHeaderOnScrollUp



      );







      window.removeEventListener(



        'scroll',



        this.onScrollHandler



      );







    }







    createObserver() {







      let observer =



        new IntersectionObserver(



          (entries, observer) => {







            this.headerBounds =



              entries[0].intersectionRect;







            observer.disconnect();







          }



        );







      observer.observe(this.header);







    }







    onScroll() {







      const scrollTop =



        window.pageYOffset ||



        document.documentElement.scrollTop;


    /*
      BÉBÉ BLEU CIEL — PHONE PORTRAIT HEADER HARD LOCK

      On phone portrait the header is intentionally permanent.
      Dawn's sticky-header state machine must not modify its classes.
      Desktop, iPad and Phone Landscape remain untouched.
    */
    if (
      window.matchMedia(
        '(max-width: 749px) and (orientation: portrait)'
      ).matches
    ) {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'scrolled-past-header',
        'animate'
      );

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

      this.currentScrollTop = scrollTop;
      return;
    }




      if (



        this.predictiveSearch &&



        this.predictiveSearch.isOpen



      ) {



        return;



      }







      if (



        scrollTop > this.currentScrollTop &&



        scrollTop > this.headerBounds.bottom



      ) {







        this.header.classList.add(



          'scrolled-past-header'



        );







        if (this.preventHide) return;







        requestAnimationFrame(



          this.hide.bind(this)



        );







      } else if (



        scrollTop < this.currentScrollTop &&



        scrollTop > this.headerBounds.bottom



      ) {







        this.header.classList.add(



          'scrolled-past-header'



        );







        if (!this.preventReveal) {







          requestAnimationFrame(



            this.reveal.bind(this)



          );







        } else {







          window.clearTimeout(



            this.isScrolling



          );







          this.isScrolling =



            setTimeout(



              () => {



                this.preventReveal = false;



              },



              66



            );







          requestAnimationFrame(



            this.hide.bind(this)



          );







        }







      } else if (



        scrollTop <= this.headerBounds.top



      ) {







        this.header.classList.remove(



          'scrolled-past-header'



        );







        requestAnimationFrame(



          this.reset.bind(this)



        );







      }







      this.currentScrollTop =



        scrollTop;







    }







    hide() {







      if (this.headerIsAlwaysSticky) return;







      this.header.classList.add(



        'shopify-section-header-hidden',



        'shopify-section-header-sticky'



      );







      this.closeMenuDisclosure();



      this.closeSearchModal();







    }







    reveal() {







      if (this.headerIsAlwaysSticky) return;







      this.header.classList.add(



        'shopify-section-header-sticky',



        'animate'



      );







      this.header.classList.remove(



        'shopify-section-header-hidden'



      );







    }







    reset() {







      if (this.headerIsAlwaysSticky) return;







      this.header.classList.remove(



        'shopify-section-header-hidden',



        'shopify-section-header-sticky',



        'animate'



      );







    }







    closeMenuDisclosure() {







      this.disclosures =



        this.disclosures ||



        this.header.querySelectorAll(



          'header-menu'



        );







      this.disclosures.forEach(



        (disclosure) =>



          disclosure.close()



      );







    }







    closeSearchModal() {







      this.searchModal =



        this.searchModal ||



        this.header.querySelector(



          'details-modal'



        );







      if (this.searchModal) {



        this.searchModal.close(false);



      }







    }







  }







  customElements.define(



    'sticky-header',



    StickyHeader



  );








  } catch(e) { console.error(e); }
})();
})();
